export type RunErrorMessageLabels = {
    runTimeoutWarning: string;
    inputContextTooLargeWarning: string;
    error: string;
};

export const runErrorMessage = (
    technicalMessage: string | null,
    code: string | null,
    labels: RunErrorMessageLabels,
): string => {
    if (technicalMessage) {
        return technicalMessage;
    }

    switch (code) {
        case 'agent_run_timeout':
            return labels.runTimeoutWarning || labels.error;
        case 'agent_input_context_too_large':
            return labels.inputContextTooLargeWarning || labels.error;
        case null:
            return '';
        default:
            return labels.error;
    }
};
